export default __webpack_public_path__ + "static/media/team.e5ebb741.png";